import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31895d34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container payroll-page" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Payroll"),
  /*#__PURE__*/_createElementVNode("p", null, "Set up employee compensation and payroll components.")
], -1))
const _hoisted_4 = {
  class: "tabs",
  role: "tablist"
}
const _hoisted_5 = {
  key: 0,
  class: "panel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Create a salary structure", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: 0,
  disabled: ""
}, "Select employee", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bank_transfer" }, "Bank transfer", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cash" }, "Cash", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "cheque" }, "Cheque", -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "component-picker" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-title" }, "Earnings and deductions", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-hint" }, " Basic salary is included automatically. Unpaid leave is calculated from the leave days you enter in a payroll run. Sales commission rates apply to the USD revenue recorded for each employee. ", -1))
const _hoisted_16 = { class: "check" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_19 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "muted"
}
const _hoisted_21 = { class: "totals" }
const _hoisted_22 = { class: "form-actions" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, " Saving creates a dated version. The previous structure remains in history and ends the day before the new effective date. ", -1))
const _hoisted_25 = {
  key: 0,
  class: "error"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Salary structure history", -1))
const _hoisted_27 = { class: "table-scroll" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Employee"),
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Effective from"),
    /*#__PURE__*/_createElementVNode("th", null, "Effective to"),
    /*#__PURE__*/_createElementVNode("th", null, "Basic salary"),
    /*#__PURE__*/_createElementVNode("th", null, "Gross"),
    /*#__PURE__*/_createElementVNode("th", null, "Deductions"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_29 = ["disabled", "onClick"]
const _hoisted_30 = {
  key: 1,
  class: "muted"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "empty"
}, " No salary structures have been saved. ", -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "panel"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Run monthly payroll", -1))
const _hoisted_36 = { class: "period-form" }
const _hoisted_37 = { class: "employee-select" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "payroll-employee-search" }, "Employees", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-hint" }, " Leave blank to include everyone with salary setup. ", -1))
const _hoisted_40 = {
  class: "employee-options",
  role: "group",
  "aria-label": "Choose payroll employees"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "muted employee-empty"
}
const _hoisted_43 = { class: "field-hint" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "error"
}
const _hoisted_46 = {
  key: 1,
  class: "run-summary"
}
const _hoisted_47 = {
  key: 2,
  class: "missing-employees"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Company employees without a salary structure", -1))
const _hoisted_49 = { class: "missing-employees-help" }
const _hoisted_50 = {
  key: 3,
  class: "note"
}
const _hoisted_51 = {
  key: 4,
  class: "table-scroll"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Employee", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Department", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Working days", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unpaid leave", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Overtime hours", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Sales revenue (USD)", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Commission (PKR)", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gross", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Deductions", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Net", -1))
const _hoisted_62 = ["onUpdate:modelValue", "disabled"]
const _hoisted_63 = ["onUpdate:modelValue", "disabled"]
const _hoisted_64 = ["onUpdate:modelValue", "disabled"]
const _hoisted_65 = ["onUpdate:modelValue", "disabled", "title"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["onUpdate:modelValue", "disabled"]
const _hoisted_68 = ["onUpdate:modelValue", "disabled"]
const _hoisted_69 = {
  key: 5,
  class: "run-actions"
}
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["disabled"]
const _hoisted_74 = {
  key: 6,
  class: "error"
}
const _hoisted_75 = {
  key: 2,
  class: "panel"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Payroll history", -1))
const _hoisted_77 = {
  key: 0,
  class: "error"
}
const _hoisted_78 = { class: "table-scroll" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Employees"),
    /*#__PURE__*/_createElementVNode("th", null, "Gross"),
    /*#__PURE__*/_createElementVNode("th", null, "Net"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_80 = ["onClick"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = ["onClick"]
const _hoisted_83 = ["onClick"]
const _hoisted_84 = { key: 0 }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty"
}, "No payroll runs yet.", -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = {
  key: 3,
  class: "panel"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Pay component master", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "earning" }, "Earning", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "deduction" }, "Deduction", -1))
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "fixed" }, "Fixed amount", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "percent" }, "Percent of basic", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "commission" }, "Commission on USD sales revenue", -1))
const _hoisted_95 = [
  _hoisted_92,
  _hoisted_93,
  _hoisted_94
]
const _hoisted_96 = { class: "check" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = {
  key: 0,
  class: "error"
}
const _hoisted_99 = { class: "table-scroll" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Calculation"),
    /*#__PURE__*/_createElementVNode("th", null, "Taxable"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_101 = { key: 0 }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { key: 0 }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty"
}, "No pay components configured.", -1))
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = {
  key: 4,
  class: "panel"
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Payslip publishing", -1))
const _hoisted_108 = {
  key: 0,
  class: "error"
}
const _hoisted_109 = { class: "table-scroll" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Employee"),
    /*#__PURE__*/_createElementVNode("th", null, "Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Net pay"),
    /*#__PURE__*/_createElementVNode("th", null, "Visibility"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "empty"
}, " No payslips are available yet. Approve a payroll run to generate them. ", -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = {
  key: 5,
  class: "panel"
}
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Payroll settings", -1))
const _hoisted_117 = { class: "wide" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "field-hint wide" }, " Enter the approved USD → PKR rate for this payroll period. The rate is stored with the calculated payroll entry so the commission can be audited later. ", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "monthly" }, "Monthly", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "biweekly" }, "Bi-weekly", -1))
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = { class: "wide" }
const _hoisted_123 = { class: "tax-editor wide" }
const _hoisted_124 = { class: "tax-header" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Pakistan salary tax slabs (PKR annual)"),
  /*#__PURE__*/_createElementVNode("p", null, " Configure progressive annual brackets and review them each tax year. ")
], -1))
const _hoisted_126 = ["onUpdate:modelValue"]
const _hoisted_127 = ["onUpdate:modelValue"]
const _hoisted_128 = ["onUpdate:modelValue"]
const _hoisted_129 = ["onClick"]
const _hoisted_130 = {
  key: 0,
  class: "muted"
}
const _hoisted_131 = { class: "form-actions" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('/finance/viewFinanceDashboard')))
      }, " Finance Dashboard ")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'structures'}),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'structures'))
      }, " Salary Structure ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'components'}),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tab = 'components'))
      }, " Pay Components ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'run'}),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'run'))
      }, " Run Payroll ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'history'}),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'history'))
      }, " Payroll History ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'payslips'}),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openPayslips && _ctx.openPayslips(...args)))
      }, " Payslips ", 2),
      _createElementVNode("button", {
        class: _normalizeClass({active: _ctx.tab === 'settings'}),
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'settings'))
      }, " Payroll Settings ", 2)
    ]),
    (_ctx.tab === 'structures')
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            class: "form-grid",
            onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveStructure && _ctx.saveStructure(...args)), ["prevent"]))
          }, [
            _createElementVNode("label", null, [
              _createTextVNode(" Employee "),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.empNumber) = $event)),
                required: ""
              }, [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (employee) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: employee.empNumber,
                    value: employee.empNumber
                  }, _toDisplayString(employee.firstName) + " " + _toDisplayString(employee.lastName) + " (" + _toDisplayString(employee.employeeId) + ") ", 9, _hoisted_8))
                }), 128))
              ], 512), [
                [
                  _vModelSelect,
                  _ctx.form.empNumber,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Effective from"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.effectiveFrom) = $event)),
                type: "date",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.effectiveFrom]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Basic salary (" + _toDisplayString(_ctx.settings.currency) + ")", 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.basicSalary) = $event)),
                type: "number",
                min: "0.01",
                step: "0.01",
                required: ""
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.basicSalary,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Payment mode"),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.paymentMode) = $event))
              }, _hoisted_12, 512), [
                [_vModelSelect, _ctx.form.paymentMode]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Bank name"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.bankName) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.bankName,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _createTextVNode("Bank account"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.bankAccount) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.bankAccount,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeComponents, (component) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: component.id,
                  class: "component-row"
                }, [
                  _createElementVNode("label", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.selectedComponents[component.id]) = $event),
                      type: "checkbox"
                    }, null, 8, _hoisted_17), [
                      [_vModelCheckbox, _ctx.selectedComponents[component.id]]
                    ]),
                    _createTextVNode(_toDisplayString(component.name) + " (" + _toDisplayString(component.type) + ")", 1)
                  ]),
                  (
                component.calc_type === 'percent' ||
                component.calc_type === 'commission'
              )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.componentValues[component.id]) = $event),
                        type: "number",
                        min: "0",
                        max: "100",
                        step: "0.01",
                        placeholder: 
                component.calc_type === 'commission'
                  ? '% of USD sales revenue'
                  : '% of basic'
              
                      }, null, 8, _hoisted_18)), [
                        [
                          _vModelText,
                          _ctx.componentValues[component.id],
                          void 0,
                          { number: true }
                        ]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.componentValues[component.id]) = $event),
                        type: "number",
                        min: "0",
                        step: "0.01",
                        placeholder: `${_ctx.settings.currency} amount`
                      }, null, 8, _hoisted_19)), [
                        [
                          _vModelText,
                          _ctx.componentValues[component.id],
                          void 0,
                          { number: true }
                        ]
                      ])
                ]))
              }), 128)),
              (_ctx.activeComponents.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, " No additional pay components configured. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", null, [
                _createTextVNode("Gross "),
                _createElementVNode("b", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.gross.toFixed(2)), 1)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode("Deductions "),
                _createElementVNode("b", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.deductions.toFixed(2)), 1)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode("Net "),
                _createElementVNode("b", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString((_ctx.gross - _ctx.deductions).toFixed(2)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "primary",
                disabled: _ctx.saving
              }, " Save versioned structure ", 8, _hoisted_23)
            ])
          ], 32),
          _hoisted_24,
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("table", null, [
              _hoisted_28,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structures, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.employee_id), 1),
                    _createElementVNode("td", null, _toDisplayString(item.effective_from), 1),
                    _createElementVNode("td", null, _toDisplayString(item.effective_to || 'Current'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(item.basic_salary)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.structureTotal(item, 'earning')), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.structureTotal(item, 'deduction')), 1),
                    _createElementVNode("td", null, [
                      (!Number(item.used_in_payroll))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "text-button",
                            disabled: _ctx.saving,
                            onClick: ($event: any) => (_ctx.deleteStructure(Number(item.id)))
                          }, " Delete version ", 8, _hoisted_29))
                        : (_openBlock(), _createElementBlock("span", _hoisted_30, "Used in payroll history"))
                    ])
                  ]))
                }), 128)),
                (_ctx.structures.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_31, _hoisted_33))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : (_ctx.tab === 'run')
        ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", null, [
                _createTextVNode("Period start"),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.periodStart) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, _ctx.periodStart]
                ])
              ]),
              _createElementVNode("label", null, [
                _createTextVNode("Period end"),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.periodEnd) = $event)),
                  type: "date"
                }, null, 512), [
                  [_vModelText, _ctx.periodEnd]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                  id: "payroll-employee-search",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.employeeSearch) = $event)),
                  type: "search",
                  placeholder: "Search by employee name or ID",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, _ctx.employeeSearch]
                ]),
                _createElementVNode("div", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEmployees, (employee) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: employee.empNumber,
                      class: "employee-option"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedEmployeeNumbers) = $event)),
                        type: "checkbox",
                        value: employee.empNumber
                      }, null, 8, _hoisted_41), [
                        [_vModelCheckbox, _ctx.selectedEmployeeNumbers]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(employee.firstName) + " " + _toDisplayString(employee.lastName) + " (" + _toDisplayString(employee.employeeId) + ")", 1)
                    ]))
                  }), 128)),
                  (_ctx.filteredEmployees.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_42, " No employees match this search. "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.selectedEmployeeNumbers.length
              ? `${_ctx.selectedEmployeeNumbers.length} selected`
              : 'All eligible employees'), 1)
              ]),
              _createElementVNode("button", {
                class: "primary",
                disabled: _ctx.saving,
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.createRun && _ctx.createRun(...args)))
              }, _toDisplayString(_ctx.runs.some(
              (run) =>
                run.period_start === _ctx.periodStart &&
                run.period_end === _ctx.periodEnd &&
                ['approved', 'paid'].includes(run.status),
            ) &&
            !_ctx.runs.some(
              (run) =>
                run.period_start === _ctx.periodStart &&
                run.period_end === _ctx.periodEnd &&
                run.status === 'draft',
            )
              ? 'Create supplemental draft run'
              : 'Create draft run'), 9, _hoisted_44)
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            (_ctx.currentRun)
              ? (_openBlock(), _createElementBlock("p", _hoisted_46, " Run #" + _toDisplayString(_ctx.currentRun.id) + " · " + _toDisplayString(_ctx.currentRun.period_start) + " to " + _toDisplayString(_ctx.currentRun.period_end) + " · " + _toDisplayString(_ctx.currentRun.status) + " · " + _toDisplayString(_ctx.currentRun.employee_count) + " employees · Gross " + _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(_ctx.currentRun.total_gross)) + " · Net " + _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(_ctx.currentRun.total_net)), 1))
              : _createCommentVNode("", true),
            (_ctx.currentRun?.missingEmployees?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("p", _hoisted_49, " These employees can’t be added until a salary structure is effective by " + _toDisplayString(_ctx.currentRun.period_end) + ". ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRun.missingEmployees, (employee) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: employee.emp_number
                    }, _toDisplayString(employee.first_name) + " " + _toDisplayString(employee.last_name) + " (" + _toDisplayString(employee.employee_id) + ")", 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentRun && _ctx.currentRun.status === 'draft')
              ? (_openBlock(), _createElementBlock("p", _hoisted_50, " Review attendance and adjustments, recalculate, then approve to lock the period and generate payslips. "))
              : _createCommentVNode("", true),
            (_ctx.currentRun && _ctx.currentRun.entries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("table", null, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_52,
                        _hoisted_53,
                        _hoisted_54,
                        _hoisted_55,
                        _hoisted_56,
                        _hoisted_57,
                        _hoisted_58,
                        _createElementVNode("th", null, "Bonus (" + _toDisplayString(_ctx.settings.currency) + ")", 1),
                        _createElementVNode("th", null, "Loan (" + _toDisplayString(_ctx.settings.currency) + ")", 1),
                        _hoisted_59,
                        _hoisted_60,
                        _hoisted_61
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRun.entries, (entry) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: entry.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(entry.first_name) + " " + _toDisplayString(entry.last_name) + " (" + _toDisplayString(entry.employee_id) + ") ", 1),
                          _createElementVNode("td", null, _toDisplayString(entry.department || '—'), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.working_days) = $event),
                              type: "number",
                              min: "0",
                              step: "0.5",
                              disabled: _ctx.currentRun.status !== 'draft'
                            }, null, 8, _hoisted_62), [
                              [
                                _vModelText,
                                entry.working_days,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.leave_days) = $event),
                              type: "number",
                              min: "0",
                              step: "0.5",
                              disabled: _ctx.currentRun.status !== 'draft'
                            }, null, 8, _hoisted_63), [
                              [
                                _vModelText,
                                entry.leave_days,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.overtime_hours) = $event),
                              type: "number",
                              min: "0",
                              step: "0.25",
                              disabled: _ctx.currentRun.status !== 'draft'
                            }, null, 8, _hoisted_64), [
                              [
                                _vModelText,
                                entry.overtime_hours,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.sales_revenue_usd) = $event),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              disabled: 
                    _ctx.currentRun.status !== 'draft' ||
                    Number(entry.commission_rate) <= 0
                  ,
                              title: 
                    Number(entry.commission_rate) > 0
                      ? `Commission rate: ${entry.commission_rate}%`
                      : 'Set up a sales commission component in this employee salary structure first'
                  
                            }, null, 8, _hoisted_65), [
                              [
                                _vModelText,
                                entry.sales_revenue_usd,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            (Number(entry.commission_rate) > 0)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_66, _toDisplayString(entry.commission_rate) + "% rate", 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.money(
                    ((Number(entry.sales_revenue_usd || 0) *
                      Number(entry.commission_rate || 0)) /
                      100) *
                      Number(_ctx.settings.usd_pkr_rate || 0),
                  )), 1),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.bonus) = $event),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              disabled: _ctx.currentRun.status !== 'draft'
                            }, null, 8, _hoisted_67), [
                              [
                                _vModelText,
                                entry.bonus,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((entry.loanInstallment) = $event),
                              type: "number",
                              min: "0",
                              step: "0.01",
                              disabled: _ctx.currentRun.status !== 'draft'
                            }, null, 8, _hoisted_68), [
                              [
                                _vModelText,
                                entry.loanInstallment,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(_ctx.money(entry.gross)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.money(entry.total_deductions)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.money(entry.net)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentRun)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  (_ctx.currentRun.status === 'draft')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "secondary",
                        disabled: _ctx.saving,
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.addEmployeesToRun && _ctx.addEmployeesToRun(...args)))
                      }, _toDisplayString(_ctx.selectedEmployeeNumbers.length
              ? 'Add selected employees'
              : 'Add all eligible employees'), 9, _hoisted_70))
                    : _createCommentVNode("", true),
                  (_ctx.currentRun.status === 'draft')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "secondary",
                        disabled: _ctx.saving,
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.recalculateRun && _ctx.recalculateRun(...args)))
                      }, " Recalculate", 8, _hoisted_71))
                    : _createCommentVNode("", true),
                  (_ctx.currentRun.status === 'draft')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "primary",
                        disabled: _ctx.saving,
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.runAction('approve')))
                      }, " Approve & generate payslips", 8, _hoisted_72))
                    : _createCommentVNode("", true),
                  (_ctx.currentRun.status === 'approved')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "primary",
                        disabled: _ctx.saving,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.runAction('paid')))
                      }, " Mark paid & post Salaries expense ", 8, _hoisted_73))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.tab === 'history')
          ? (_openBlock(), _createElementBlock("section", _hoisted_75, [
              _hoisted_76,
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("table", null, [
                  _hoisted_79,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.runs, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.period_start) + " to " + _toDisplayString(item.period_end), 1),
                        _createElementVNode("td", null, _toDisplayString(item.employee_count), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(item.total_gross)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(item.total_net)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.status), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            class: "text-button",
                            onClick: ($event: any) => (_ctx.openRun(Number(item.id)))
                          }, " View run", 8, _hoisted_80),
                          (['approved', 'paid'].includes(item.status))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "text-button",
                                onClick: ($event: any) => (_ctx.downloadBankFile(Number(item.id)))
                              }, " Bank CSV", 8, _hoisted_81))
                            : _createCommentVNode("", true),
                          (item.status === 'paid')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "text-button",
                                onClick: ($event: any) => (_ctx.reverseRun(Number(item.id)))
                              }, " Reverse", 8, _hoisted_82))
                            : _createCommentVNode("", true),
                          (item.status === 'draft')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "text-button",
                                onClick: ($event: any) => (_ctx.deleteRun(Number(item.id)))
                              }, " Delete draft ", 8, _hoisted_83))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    (_ctx.runs.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_84, _hoisted_86))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : (_ctx.tab === 'components')
            ? (_openBlock(), _createElementBlock("section", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("form", {
                  class: "component-form",
                  onSubmit: _cache[27] || (_cache[27] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveComponent && _ctx.saveComponent(...args)), ["prevent"]))
                }, [
                  _createElementVNode("label", null, [
                    _createTextVNode("Name"),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.componentForm.name) = $event)),
                      required: "",
                      maxlength: "100"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.componentForm.name,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode("Type"),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.componentForm.type) = $event))
                    }, _hoisted_91, 512), [
                      [_vModelSelect, _ctx.componentForm.type]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createTextVNode("Calculation"),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.componentForm.calcType) = $event))
                    }, _hoisted_95, 512), [
                      [_vModelSelect, _ctx.componentForm.calcType]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_96, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.componentForm.isTaxable) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.componentForm.isTaxable]
                    ]),
                    _createTextVNode("Taxable earning")
                  ]),
                  _createElementVNode("button", {
                    class: "primary",
                    disabled: _ctx.saving
                  }, "Add component", 8, _hoisted_97)
                ], 32),
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("table", null, [
                    _hoisted_100,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.type), 1),
                          _createElementVNode("td", null, _toDisplayString(item.calc_type), 1),
                          _createElementVNode("td", null, _toDisplayString(Number(item.is_taxable) ? 'Yes' : 'No'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.name.trim().toLowerCase() === 'basic salary'
                    ? 'System item'
                    : Number(item.is_active)
                    ? 'Active'
                    : 'Inactive'), 1),
                          _createElementVNode("td", null, [
                            (
                    ['basic salary', 'unpaid leave'].includes(
                      item.name.trim().toLowerCase(),
                    )
                  )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_101, "Calculated automatically"))
                              : (Number(item.is_active))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "text-button",
                                    onClick: ($event: any) => (_ctx.deactivateComponent(item))
                                  }, " Deactivate ", 8, _hoisted_102))
                                : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.components.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_103, _hoisted_105))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : (_ctx.tab === 'payslips')
              ? (_openBlock(), _createElementBlock("section", _hoisted_106, [
                  _hoisted_107,
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("table", null, [
                      _hoisted_110,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payslips, (slip) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: slip.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(slip.first_name) + " " + _toDisplayString(slip.last_name) + " (" + _toDisplayString(slip.employee_id) + ") ", 1),
                            _createElementVNode("td", null, _toDisplayString(slip.period_start) + " — " + _toDisplayString(slip.period_end), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.settings.currency) + " " + _toDisplayString(_ctx.money(slip.net)), 1),
                            _createElementVNode("td", null, _toDisplayString(slip.published_at ? 'Published' : 'Hidden'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                class: "text-button",
                                onClick: ($event: any) => (_ctx.togglePayslip(slip))
                              }, _toDisplayString(slip.published_at ? 'Unpublish' : 'Publish'), 9, _hoisted_111)
                            ])
                          ]))
                        }), 128)),
                        (_ctx.payslips.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_112, _hoisted_114))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_115, [
                  _hoisted_116,
                  _createElementVNode("form", {
                    class: "form-grid",
                    onSubmit: _cache[37] || (_cache[37] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("label", _hoisted_117, [
                      _createTextVNode("USD to PKR exchange rate"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.settings.usd_pkr_rate) = $event)),
                        type: "number",
                        min: "0",
                        max: "10000",
                        step: "0.0001"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.usd_pkr_rate,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _hoisted_118,
                    _createElementVNode("label", null, [
                      _createTextVNode("Currency"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.settings.currency) = $event)),
                        maxlength: "3",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.currency,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Pay frequency"),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.settings.pay_frequency) = $event))
                      }, _hoisted_121, 512), [
                        [_vModelSelect, _ctx.settings.pay_frequency]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Working days per month"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.settings.working_days_per_month) = $event)),
                        type: "number",
                        min: "1",
                        max: "31",
                        step: "0.5",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.working_days_per_month,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Overtime multiplier"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.settings.overtime_multiplier) = $event)),
                        type: "number",
                        min: "1",
                        max: "5",
                        step: "0.1",
                        required: ""
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.overtime_multiplier,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Pay day"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.settings.pay_day) = $event)),
                        type: "number",
                        min: "1",
                        max: "31"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.pay_day,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _createTextVNode("Tax year starts in"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.settings.tax_year_start) = $event)),
                        type: "number",
                        min: "1",
                        max: "12"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.tax_year_start,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_122, [
                      _createTextVNode("Payslip footer"),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.settings.payslip_footer) = $event)),
                        maxlength: "255"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.settings.payslip_footer,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        _hoisted_125,
                        _createElementVNode("button", {
                          type: "button",
                          class: "secondary",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.settings.tax_slabs.push({upTo: 0, baseTax: 0, rate: 0})))
                        }, " Add slab ")
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settings.tax_slabs, (slab, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "tax-row"
                        }, [
                          _createElementVNode("label", null, [
                            _createTextVNode("Annual income up to"),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((slab.upTo) = $event),
                              type: "number",
                              min: "1",
                              step: "1"
                            }, null, 8, _hoisted_126), [
                              [
                                _vModelText,
                                slab.upTo,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _createTextVNode("Base tax"),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((slab.baseTax) = $event),
                              type: "number",
                              min: "0",
                              step: "1"
                            }, null, 8, _hoisted_127), [
                              [
                                _vModelText,
                                slab.baseTax,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("label", null, [
                            _createTextVNode("Rate %"),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((slab.rate) = $event),
                              type: "number",
                              min: "0",
                              max: "100",
                              step: "0.01"
                            }, null, 8, _hoisted_128), [
                              [
                                _vModelText,
                                slab.rate,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-button danger",
                            onClick: ($event: any) => (_ctx.settings.tax_slabs.splice(index, 1))
                          }, " Remove ", 8, _hoisted_129)
                        ]))
                      }), 128)),
                      (_ctx.settings.tax_slabs.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_130, " No automatic tax brackets configured. "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("button", {
                        class: "primary",
                        disabled: _ctx.saving
                      }, "Save settings", 8, _hoisted_132)
                    ])
                  ], 32),
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_133, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
                ]))
  ]))
}